import { Component, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import * as globals from '../globals';

@Component({
    selector: 'translate-model',
    templateUrl: './translatemodel.component.html',
    styleUrls: ['./translatemodel.component.css']
  })
  export class TranslateModelComponent {

  modalShowTranslateAction = new EventEmitter<string | MaterializeAction>();

  translatemodelid: string = '';
  translatename: string = '';
  translatefilename: string = '';
  translatetype: string = 'stp';
  translatetenantid: string = '';
  translatetenanturl: string = '';
  translatebucketname: string = '';
  // 0=loading, 1=file not present, 2=file present
  translatePDF: number = 0;
  translateSTP: number = 0;
  translateSTL: number = 0;
  isProcessingCount: number = 0;
  processingtry: number = 0;
  translatetimer: any;
  translatetimerlength: number = 10000;
  errorMessage: string = '';

  private projectsUrl = globals.APIURL + '/projects';
  private translateUrl = this.projectsUrl + '/translate';
  private translateStatusUrl = this.translateUrl + '/status';
  constructor(private http: Http, public authHttp: AuthHttp) { }

  ngOnDestroy() {
    this.modalShowTranslateAction.emit({ action: 'modal', params: ['close'] });
  }

onShowTranslate(modelid: string, name: string, filename: string, tenantid: string, tenanturl: string, bucketname: string) {
    // 0=not found, 1=translating, 2=file found, 3=error translating
    this.translatePDF = -1;
    this.translateSTP = -1;
    this.translateSTL = -1;
    this.modalShowTranslateAction.emit({ action: 'modal', params: ['open'] });
    console.log('modelid:', modelid);
    console.log('name:', name);
    console.log('filename:', filename);

    this.translatemodelid = modelid;
    this.translatename = name;
    this.translatefilename = filename;
    this.translatetenantid = tenantid;
    this.translatetenanturl = tenanturl;
    this.translatebucketname = bucketname;

    this.translationCheck(this.translatetenantid, modelid)
    .subscribe(
      data => {
        console.log('TranslationCheck Status:', data);
        let json = JSON.parse(data);
        this.translateSTL = json.STL;
        this.translateSTP = json.STP;
        this.translatePDF = json.PDF;
        if (this.translateSTL == 1 || this.translateSTP == 1 || this.translatePDF == 1) {
          // Start the timer
          console.log('Translation detected.  Starting timer.');
          this.translatetimer = Observable.timer(this.translatetimerlength);
          this.translatetimer.subscribe(t => this.checkTranslationStatus());
        }
      },
      error => {
        console.error('Unable to get file status:', error.err);
      }
    );
  }

  checkTranslationStatus() {
    console.log('Calling checkTranslationStatus()');
    this.translationCheck(this.translatetenantid, this.translatemodelid)
    .subscribe(
      data => {
        console.log('Translation status:', data);
        let json = JSON.parse(data);
        this.translateSTL = json.STL;
        this.translateSTP = json.STP;
        this.translatePDF = json.PDF;

        if (this.translateSTL == 1 || this.translateSTP == 1 || this.translatePDF == 1) {
          // Start the timer again
          console.log('Detected something still being translated.  Starting timer again.');
          this.translatetimer = Observable.timer(this.translatetimerlength);
          this.translatetimer.subscribe(t => this.checkTranslationStatus());
        } else {
          console.log('Nothing translating, so done.');
        }
      },
      error => {
        console.error('Unable to get file status:', error.err);
      }
    );
  }

  translationCheck(tenantid: string, projectid: string): Observable<string> {
    console.log('translationCheck service called');
    let body = JSON.stringify({ tenantid: tenantid, projectid: projectid });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.translateStatusUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  translate(type: string) {

    if (type === 'stl') {
      this.translateSTL = 1;
    } else if (type === 'stp') {
      this.translateSTP = 1;
    } else if (type === 'pdf') {
      this.translatePDF = 1;
    } else {

    }

    this.startTranslation(this.translatetenantid, this.translatemodelid, this.translatefilename, '.' + type)
    .subscribe(
      data => {
        console.log('startProcessing data:', data);
        // Start a timer to refresh the page when translation is complete
        this.translatetimer = Observable.timer(this.translatetimerlength);
        this.translatetimer.subscribe(t => this.checkTranslationStatus());
      },
      error => {
        this.errorMessage = <any>error;
        console.error('startProcessing error:', this.errorMessage);
      }
    );
  }

  startTranslation(tenantid: string, projectid: string, filename: string, type: string): Observable<string> {
    console.log('startTranslation service method called');

    let body = JSON.stringify({ tenantid: tenantid, projectid: projectid, filename: filename, type: type });
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers });
    // console.log('URL =>', this.translateUrl);
    // console.log('BODY =>', body);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.translateUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  onDownloadTranslated(typeextension: string) {
    let url = this.translatetenanturl + '/' + this.translatebucketname + '/' + this.translatetenantid + '/' + this.translatemodelid + '/' + this.translatename + '.' + typeextension;
    // console.log('Translated file URL:', url);
    window.open(url);
  }

  onDownloadOriginal() {
    let url = this.translatetenanturl + '/' + this.translatebucketname + '/' + this.translatetenantid + '/' + this.translatemodelid + '/' + this.translatefilename;
    // console.log('Original URL:', url);
    window.open(url);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/translatemodel/translatemodel.component.ts